module.exports = __webpack_public_path__ + "img/top_company.2dfdb728.jpg";